import React, { useState } from "react";
import {
Box,
Button,
Divider,
Grid,
TextField,
Typography,
Paper
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Swal from "sweetalert2";

import { postRequest } from "Includes/api/apicall";
import { POST_URL } from "Includes/urls";
import { Actions } from "Constants/permissions";

const ManageYear = (props) => {
const navigate = useNavigate();


const [manageyear, setManageYear] = useState({
    name: "",
    code: "",
    description: "",
});

const [errors, setErrors] = useState({});
const [submitDisable, setSubmitDisable] = useState(false);

const validate = () => {
    const newErrors = {};
    let isValid = true;

    if (!manageyear.name) {
        newErrors.name = "Name is required";
        isValid = false;
    }

    if (!manageyear.code) {
        newErrors.code = "Code is required";
        isValid = false;
    }

    if (!manageyear.description) {
        newErrors.description = "Description is required";
        isValid = false;
    }

    setErrors(newErrors);
    return isValid;
};

const submitYear = async () => {
    if (!validate()) return;

    setSubmitDisable(true);

    const url = POST_URL.academicyear.api;

    const post_data = [{
        name: manageyear.name,
        code: manageyear.code,
        description: manageyear.description,
    }];

    try {
        const response = await postRequest(url, post_data, props);
        setSubmitDisable(false);

        if (response?.status === 200) {
            Swal.fire({
                position: "top-end",
                icon: "success", // ✅ fixed
                title: response.data.Reason,
                showConfirmButton: false,
                timer: 1500,
            });

            navigate("/academicyear/list"); // ✅ fixed
        }
    } catch (err) {
        setSubmitDisable(false);
    }
};

const onChangeField = (e) => {
    const { name, value } = e.target;

    setManageYear((prev) => ({
        ...prev,
        [name]: value
    }));

    if (errors[name]) {
        setErrors((prev) => {
            const updated = { ...prev };
            delete updated[name];
            return updated;
        });
    }
};

const sectionTitleSx = {
    mb: 2.5,
    pl: 1.75,
    borderLeft: "4px solid #4680FF",
    color: "#4680FF",
    fontWeight: 600,
};

const sectionPaperSx = {
    p: 3,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    bgcolor: "background.paper",
};

return (
    <Box sx={{ p: 3 }}>
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
                <Typography variant="h5" fontWeight={600}>
                    Academic Year Informations
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Create and configure a new academic year
                </Typography>
            </Grid>

            <Grid item xs={12} md={6} textAlign="right">
                <Button
                    variant="contained"
                    component={Link}
                    to={Actions.academic_year.view.url}
                    startIcon={<VisibilityOutlinedIcon />}
                >
                    {Actions.academic_year.view.label}
                </Button>
            </Grid>
        </Grid>

        <Box mt={3} mb={3}>
            <Divider />
        </Box>

        <Paper sx={{ ...sectionPaperSx, maxWidth: 760 }}>
            <Typography variant="subtitle1" sx={sectionTitleSx}>
                Academic Year Details
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        label="Name"
                        fullWidth
                        name="name"
                        value={manageyear.name}
                        onChange={onChangeField}
                        error={!!errors.name}
                        helperText={errors.name}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label="Code"
                        fullWidth
                        name="code"
                        value={manageyear.code}
                        onChange={onChangeField}
                        error={!!errors.code}
                        helperText={errors.code}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label="Description"
                        fullWidth
                        multiline
                        rows={4}
                        name="description"
                        value={manageyear.description}
                        onChange={onChangeField}
                        error={!!errors.description}
                        helperText={errors.description}
                    />
                </Grid>
            </Grid>

            <Box mt={3} display="flex" justifyContent="flex-end" gap={1.5}>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setManageYear({ name: "", code: "", description: "" });
                        setErrors({});
                    }}
                >
                    Reset
                </Button>

                <Button
                    variant="contained"
                    disabled={submitDisable}
                    onClick={submitYear}
                >
                    {submitDisable ? "Saving..." : "Submit"}
                </Button>
            </Box>
        </Paper>
    </Box>
);
};

export default ManageYear;
